module.exports = {
      id: "politics-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#politics",
      toString: function () {
        return this.url;
      }
    }